var map = {
	"./aliexpress.png": "c7b1",
	"./amazon.png": "226f",
	"./cmoffer.png": "034e",
	"./ebay.png": "c1e3",
	"./etsy.png": "1ad3",
	"./shopify.png": "ea91",
	"./shoplazza.png": "73ad",
	"./shopline.png": "2599"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b1a0";